import { render } from "./legoDropdownMenu.vue?vue&type=template&id=e9c36370&scoped=true"
import script from "./legoDropdownMenu.vue?vue&type=script&lang=js"
export * from "./legoDropdownMenu.vue?vue&type=script&lang=js"

import "./legoDropdownMenu.vue?vue&type=style&index=0&id=e9c36370&lang=scss&scoped=true"
import "./legoDropdownMenu.vue?vue&type=style&index=1&id=e9c36370&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c36370"],['__file',"src/components/lego/extend/legoDropdownMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9c36370"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9c36370', __exports__)) {
    api.reload('e9c36370', __exports__)
  }
  
  module.hot.accept("./legoDropdownMenu.vue?vue&type=template&id=e9c36370&scoped=true", () => {
    api.rerender('e9c36370', render)
  })

}


export default __exports__